var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.loading
    ? _c(
        "div",
        {
          staticClass:
            "flex h-full justify-center font-outfit loadingClass items-center",
        },
        [
          _c("StatusIndicator", {
            staticClass: "flex justify-center items-center",
            attrs: { status: "active", pulse: "" },
          }),
          _c("h3", { staticClass: "ml-3 font-medium" }, [_vm._v("Signing in")]),
        ],
        1
      )
    : _c(
        "div",
        {
          staticClass:
            "w-full flex flex-col items-center justify-center font-outfit",
        },
        [
          _c("JobBlissLogo", { staticClass: "logo" }),
          _c("h3", { staticClass: "welcomeText" }, [_vm._v("Sign in")]),
          _c("h5", { staticClass: "subText text-center mb-7" }, [
            _vm._v(
              "If you’re a manager please sign in using your business email"
            ),
          ]),
          _c("ValidationObserver", {
            staticClass: "flex flex-col overflow-hidden",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ invalid, dirty, handleSubmit }) {
                  return [
                    _c(
                      "form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return handleSubmit(_vm.submit)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "formContainer" },
                          [
                            _c("ValidationProvider", {
                              staticClass: "w-full",
                              attrs: {
                                name: "Email address",
                                rules: "c_email|required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors, touched }) {
                                      return [
                                        _c("FormGroup", {
                                          staticClass: "mb-4",
                                          attrs: {
                                            inputClass:
                                              "fullwidthInput customSignText",
                                            isIcon: false,
                                            name: "email",
                                            type: "email",
                                            placeholder: "Email",
                                            errors: touched ? errors : [],
                                          },
                                          model: {
                                            value: _vm.username,
                                            callback: function ($$v) {
                                              _vm.username =
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                            },
                                            expression: "username",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c("ValidationProvider", {
                              attrs: { name: "Password", rules: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors, touched }) {
                                      return [
                                        _c("FormGroup", {
                                          attrs: {
                                            inputClass:
                                              "fullwidthInput customSignText",
                                            isIcon: false,
                                            id: "password",
                                            name: "password",
                                            type: _vm.getPasswordInputType,
                                            placeholder: "Password",
                                            errors: touched ? errors : [],
                                          },
                                          model: {
                                            value: _vm.password,
                                            callback: function ($$v) {
                                              _vm.password = $$v
                                            },
                                            expression: "password",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _vm.errorMessage
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "error-msg text-red text-italic mt-4",
                                  },
                                  [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "submit-wrapper mt-7" },
                              [
                                _c("UiButton", {
                                  attrs: {
                                    variant: "black",
                                    type: "submit",
                                    buttonClasses: "customPadding fontButton",
                                    disabled: invalid || !dirty,
                                    processing: _vm.loading,
                                    buttonText: _vm.loading
                                      ? "Loading..."
                                      : "Sign in",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "form-forgot flex flex-col items-center gap-9 mt-4",
                              },
                              [
                                _c("AuthFormLink", {
                                  staticClass:
                                    "forgot text-black font-normal hover:underline",
                                  attrs: {
                                    link: "/forgot-password",
                                    text: "Reset password",
                                  },
                                }),
                                _c("AuthFormLink", {
                                  staticClass:
                                    "forgot text-black font-normal hover:underline",
                                  attrs: {
                                    link: "/resend-signup",
                                    text: "Resend confirmation email",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }